export default "__VITE_ASSET__CHqTED3L__"